<template>

    <div class="estates-carousel-similar" v-show="show && lang">
        <div class="p-0">
            <h2 class="subtitle">{{ lang.labels.similar_estates_title }}</h2>
            <estates-carousel
                :estates="estates"
                :navigation-enabled="false"
                :per-page-custom="[[0, 1], [768, 2], [1440, 3]]"
            />
        </div>
    </div>

</template>

<script>
import Carousel from './Carousel'

export default {
    components: {
        'estates-carousel': Carousel,
    },

    props: {
        estate: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            estates: [],
            show: false
        }
    },

    computed: {
        lang() {
            return this.$root.lang.estate_detail
        },
    },

    mounted() {
        let query_string = '?section=' + this.estate.ad_type
            + '&sector=' + this.estate.sector.id
            + '&contract=' + this.estate.contract.id
            + '&latitude=' + this.estate.latitude
            + '&longitude=' + this.estate.longitude
            + '&min_price=' + (parseInt(this.estate.numeric_price) - (parseInt(this.estate.numeric_price) * .2))
            + '&max_price=' + (parseInt(this.estate.numeric_price) + (parseInt(this.estate.numeric_price) * .2))
            + '&min_surface=' + (parseInt(this.estate.numeric_surface) - (parseInt(this.estate.numeric_surface) * .3))
            + '&max_surface=' + (parseInt(this.estate.numeric_surface) + (parseInt(this.estate.numeric_surface) * .3))
            + '&hidden=' + this.estate.id
            + '&agency=' + this.estate.agency.id
            + '&radius=30&limit=5&no_fallback=1'
        //  + '&type=' + this.estate.type.id

        axios.get('/api/estates/search' + query_string)
            .then(({data}) => {
                if (data.estates.length) {
                    this.estates = data.estates
                    this.show = true
                }
            })
    },
}
</script>